export const DEFAULT_PORT = 8888;

export enum Platform {
  WINDOWS = 'WINDOWS',
  LINUX = 'Linux',
  MAC = 'Mac',
}

export enum ConnectionType {
  SSM_CONNECTION = 'SSM Connection',
  PORT = 'Port',
}

export interface InstructionsConfig {
  awsRegion?: string;
  accessKeyId?: string;
  secretAccessKey?: string;
  sessionToken?: string;
  instanceId?: string;
  bucketName?: string;
  bucketFolder?: string;
  port?: number;
  roleArn?: string | null;
}

export enum ConnectionInstructionsType {
  WORKBENCH = 'Workbench',
  DATASET = 'Dataset',
}
